import React from "react";

import {
    ShowroomHeader,
    ShowroomDownloads,
    ShowroomDownloadsAttach
} from "components/showroom";
import { ShowroomMenuBar } from "components/menus";
import { ContainerWrap } from "components/wraps";
import { metaFields } from "utils";


const ShowroomDownloadsSubPage = ({ stand, control, spanList, configurator }) => {

    const { normalize } = metaFields;
    const meta = normalize(stand.meta_fields);

    return(
        <div className="showroom-downloads-wrap">
            { control &&
                <div className="badge-page-label">You are design downloads page</div>
            }
            <ContainerWrap
                spanList={ spanList }
                className="showroom-header-wrap"
            >
                <ShowroomHeader
                    stand={{
                        id : stand.id,
                        logo: stand.logo,
                        companyName: stand.title,
                        description: stand.description,
                        my_favorite: stand.my_favorite,
                        meta
                    }}
                    control={ control }
                    imageKey={ "downloads_image_1" }
                >
                    { !configurator &&
                        <ShowroomMenuBar standId={stand.id} />
                    }
                </ShowroomHeader>
            </ContainerWrap>
            <ContainerWrap
                className="showroom-content-wrap"
                spanList={ spanList }
            >
                { control &&
                    <ShowroomDownloadsAttach standId={ stand.id } />
                }
                <ShowroomDownloads
                    control={ control }
                    standId={ stand.id }
                />
            </ContainerWrap>
        </div>
    );
};

export default ShowroomDownloadsSubPage;